<template>
  <div>
    <div v-if="!jwt">Please login or sign up</div>
    <div v-else style="display: flex;">
      <SearchBox />
      <SavedSearches />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SearchBox from '@/components/search/SearchBox'
import SavedSearches from '@/components/search/SavedSearches'

export default {
  name: 'home',

  computed: {
    ...mapState({
      jwt: state => state.account.jwt,
    }),
  },

  components: {
    SearchBox,
    SavedSearches,
  },
}
</script>
